import type { GalleryQuery } from './galleryRepo';

export function roleGalleryHash(presetId?: string | null, conversationId?: string | null): string {
  const query = new URLSearchParams();
  if (presetId) query.set('presetId', presetId);
  if (conversationId) query.set('conversationId', conversationId);
  if (!presetId && !conversationId) query.set('scope', 'empty');
  return `#/gallery?${query.toString()}`;
}

export function readGalleryScope(hash: string): GalleryQuery {
  const query = new URLSearchParams(hash.split('?')[1] ?? '');
  const presetId = query.get('presetId');
  const conversationId = query.get('conversationId');
  if (presetId) return { presetId };
  if (conversationId) return { conversationId };
  return query.has('scope') || query.has('presetId') || query.has('conversationId')
    ? { empty: true } : {};
}
